export enum BreakdownType {
  VisitorsEntered = 'VisitorsEntered',
  VisitorsExited = 'VisitorsExited',
  VisitorsExitedByRule = 'VisitorsExitedByRule',
}
